import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { injectFlags } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'class()',
  },
  template: `
    @if (flags().closeSettings) {
      <span (click.prevent.stop)="onLinkClick()" class="aux-link" [attr.data-pendo-id]="pendoTag">
        {{ label() }}
      </span>
    } @else {
      {{ label() }}
    }
  `,
})
export class ExpenseSourceLink {
  router = inject(Router);

  flags = injectFlags({
    closeSettings: 'close_settings',
  });

  class = input<string>();
  label = input<string>('');

  pendoTag = 'ima-redirect-to-close-settings';

  onLinkClick() {
    void this.router.navigate([
      `/${ROUTING_PATH.SETTINGS.INDEX}/${ROUTING_PATH.SETTINGS.CLOSE_SETTINGS.INDEX}`,
    ]);
  }
}
